import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row, Button } from "react-bootstrap";
import { ArrowLeftCircle, Printer } from 'react-bootstrap-icons';

import moment from 'moment';

import NavbarComponent from '../components/NavbarComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import LoadingComponent from '../components/LoadingComponent';
import FooterComponent from '../components/FooterComponent';
import PurchaseOrder from './PurchaseOrder';

//const axios = require('axios').default;

class PackingList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            alertErrorMessage:'',
            isLoading:true,
            data:[],
            poApprovedChecked:[]
        }
    }

    componentDidMount() {
        this.initData();
    }

    initData = () => {
        let poApprovedChecked = this.props.poApprovedChecked.filter( (poId) => this.props.approvedDataPO.findIndex( (po) => po.POId === poId ) > -1 );
        if(!poApprovedChecked.length) {
            this.setState({
                isLoading:false,
                alertErrorMessage:'No purchase orders selected for packing list'
            });
        } else {
            this.setState({
                isLoading:false,
                poApprovedChecked:poApprovedChecked
            });
        }
    }

    getPOHTML = () => {
        let data = JSON.parse(JSON.stringify(this.state.poApprovedChecked)).reverse();
        return data.map( (poId, index) => {
            if(index === 0) {
                return <PurchaseOrder readOnly={true} packingList={true} weighingList={this.props.weighingList} id={poId} />
            } else {
                return (
                    <>
                        <div className="page-break" />
                        <PurchaseOrder readOnly={true} packingList={true} weighingList={this.props.weighingList} id={poId} />
                    </>
                );
            }
        });
    }

    render() {
        return (
            <>
            <Container fluid className="p-0">
                {this.props.auth.isLogin && <NavbarComponent />}
                <Container className="print-layout">
                    {this.state.isLoading
                    ?
                        <LoadingComponent />
                    :

                    <>
                        <Row className="no-print">
                            <Col xs={12}>
                                <div className="float-end mt-4">
                                    <div>
                                        <Button variant="link" className="px-0 me-4" onClick={ () => this.props.history.push('/purchase-orders/approved') }>
                                            <ArrowLeftCircle size={16} className="mb-1 me-1" /> Go Back
                                        </Button> 
                                        <Button variant="link" className="px-0" onClick={ () => window.print() }>
                                            <Printer size={16} className="mb-1 me-1" /> Print
                                        </Button> 
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="portrait-section">
                            <Col xs={12}>
                                <div className="mt-4">
                                    <h1>{this.props.weighingList ? `Weighing List` : `Packing List`}</h1>
                                </div>
                                {
                                    this.state.alertErrorMessage
                                    ?
                                        <div className="mt-4">
                                            <AlertErrorComponent label={this.state.alertErrorMessage} />
                                        </div>
                                    :
                                    <>
                                    <div className="mt-4 only-print">
                                        Consolidated packing list printed on {moment().format('LT - Do MMMM YYYY')}
                                    </div>
                                    {this.getPOHTML()}
                                    </>
                                }
                            </Col>
                        </Row>
                    </>
                    }
                </Container>
            </Container>
            <FooterComponent />
            </>
        )
    }

}

const mapStateToProps = state => {
    const {
        auth, 
        poApprovedChecked, 
        approvedDataPO
    } = state;

    return { 
        auth: auth, 
        poApprovedChecked:poApprovedChecked,
        approvedDataPO:approvedDataPO
    };
};

export default connect(mapStateToProps, null)(withRouter(PackingList));